var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"breadcrumb"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.productType))]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.productName))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }